<template>
  <div class="headerWrapper">
    <b-nav-item-dropdown right no-caret>
      <template slot="button-content">
        <i class="icon-user bg-primary p-3 font-2xl mr-2" />
        <span class="user-account-username">{{this.username}}</span>
      </template>
      <b-dropdown-header tag="div"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="logout" class="logout"><i class="fa fa-power-off"></i>Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
  export default {
    name: 'header-dropdown-accnt',
    data: () => {
      return {
        username: ''
      }
    },
    methods: {
      logout () {
        this.$http.post(this.API_ENDPOINT + '/operator/logout', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          window.sessionStorage.clear()
          this.$router.go('/')
        }).catch(err => {
          console.log('this is an error ', err)
        })
      }
    },
    created () {
      if (window.sessionStorage.getItem('client')) {
        const user = JSON.parse(window.sessionStorage.getItem('client'))
        this.username = user.username
      }
    }
  }
</script>

<style>
.logout .dropdown-item {
  min-width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue